// components/Inbox/InboxRouter.js
import React from 'react';

// ============================================================================
// VERIFICATION COMPONENTS - Import only what you need
// ============================================================================
import VerifyStaffRegistration from '../../pages/HR/VerifyStaffRegistration';
import VerifyVendorPayment from '../../pages/VendorPayment/VerifyVendorPayment';
import VerifySupplierInvoice from '../../pages/VendorInvoice/VerifySupplierInvoice';
import VerifySupplierPO from '../../pages/SupplierPO/VerifySupplierPO';
import VerifySupplierPOAmend from '../../pages/SupplierPO/VerifySupplierPOAmend';
import VerifySPPO from '../../pages/SPPO/VerifySPPO';
import InboxItemPlaceholder from './InboxItemPlaceholder';
import CostCenterApproval from '../../pages/CostCenter/CostCenterApproval';
import GeneralInvoiceApproval from '../../pages/GeneralInvoice/GeneralInvoiceApproval';
import VerifyCCBudgetAmendment from '../../pages/Budget/VerifyCCBudgetAmendment';
import VerifyDCABudgetAmendment from '../../pages/Budget/VerifyDCABudgetAmendment';
import VerifyClientPO from '../../pages/ClientPO/VerifyClientPO';
import VerifyMiscInvoice from '../../pages/Accounts/VerifyMiscInvoice';
import VerifyMiscPayment from '../../pages/Accounts/VerifyMiscPayment';
import LostDamagedItemsVerification from '../../pages/Stock/LostDamagedItemsVerification';
import VerifyDailyIssue from '../../pages/Stock/VerifyDailyIssue';
import VerifyScrapSale from '../../pages/Stock/VerifyScrapSale';
import VerifySPPOClose from '../../pages/SPPO/VerifySPPOClose';
import VerifySPPOAmend from '../../pages/SPPO/VerifySPPOAmend';
import VerifyExcelAttendance from '../../pages/HR/VerifyExcelAttendance';
import VerifyStaffDailyAttendance from '../../pages/HR/VerifyStaffDailyAttendance';
import VerifyLabourObjectivesGoals from '../../pages/HR/VerifyLabourObjectivesGoals';
import VerifyStaffObjectivesGoals from '../../pages/HR/VerifyStaffObjectivesGoals';
import VerifyEmployeeCTC from '../../pages/HR/VerifyEmployeeCTC';
import VerifyLabourCTC from '../../pages/HR/VerifyLabourCTC';
import VerifyLabourPayRoll from '../../pages/HR/VerifyLabourPayRoll';
import VerifyLabourPayRevision from '../../pages/HR/VerifyLabourPayRevision';
import VerifyStaffPayRevision from '../../pages/HR/VerifyStaffPayRevision';
import VerifyEmployeeLeaveRequest from '../../pages/HR/VerifyEmployeeLeaveRequest';
import DividendDeclarationVerification from '../../pages/shares/DividendDeclarationVerification';
import DividendDistributionVerification from '../../pages/shares/DividendDistributionVerification';
import DividendBankPaymentVerification from '../../pages/shares/DividendBankPaymentVerification';
import VerifyStaffCMSPay from '../../pages/HR/VerifyStaffCMSPay';
import VerifyStaffPayroll from '../../pages/HR/VerifyStaffPayroll';
import VerifySalaryDeductionArear from '../../pages/HR/VerifySalaryDeductionArear';
import VerifyEmployeeTransfer from '../../pages/HR/VerifyEmployeeTransfer';
import VerifyEmployeeExit    from '../../pages/HR/VerifyEmployeeExit';
import VerifyLabourExit      from '../../pages/HR/VerifyLabourExit';
import VerifyStaffFullFinal from '../../pages/HR/VerifyStaffFullFinal';
import VerifyStaffAdvance from '../../pages/HR/VerifyStaffAdvance';
import VerifyStaffAppraisal from '../../pages/HR/VerifyStaffAppraisal';
import VerifyCashVoucher from '../../pages/Accounts/VerifyCashVoucher';
import VerifyVendorPaymentByCash from '../../pages/Accounts/VerifyVendorPaymentByCash';
import VerifyCCCashTransfer from '../../pages/Accounts/VerifyCCCashTransfer';
import VerifyCCClosing from '../../pages/Accounts/VerifyCCClosing';
import VerifyLoadWallet from '../../pages/Accounts/VerifyLoadWallet';
import VerifyLabourCMSPay from '../../pages/HR/VerifyLabourCMSPay';
import VerifyBulkWorker from '../../pages/HR/VerifyBulkWorker';
import VerifyWorkerStaffReg from '../../pages/HR/VerifyWorkerStaffReg';
import VerifyLabourBankChange from '../../pages/HR/VerifyLabourBankChange';
import VerifyEmpBankChange from '../../pages/HR/VerifyEmpBankChange';
import VerifyLabourTypeChange from '../../pages/HR/VerifyLabourTypeChange';
import VerifyHRAdvancePayment from '../../pages/HR/VerifyHRAdvancePayment';
import VerifyItemCode from '../../pages/Purchase/VerifyItemCode';
import VerifyIndentCreation from '../../pages/Purchase/VerifyIndentCreation';
import TransferRecieptOthersVerification from '../../pages/Purchase/TransferRecieptOthersVerification';
import VerifyNewStockReceived from '../../pages/Purchase/VerifyNewStockReceived';
import VerifyIndentAmend from '../../pages/Purchase/VerifyIndentAmend';
import VerifyVendor from '../../pages/Purchase/VerifyVendor';
import VerifyClientRecievable from '../../pages/Accounts/VerifyClientRecievable';
import VerifyAdvancePayment from '../../pages/Accounts/VerifyAdvancePayment';
import VerifyRetentionPayment from '../../pages/Accounts/VerifyRetentionPayment';
import VerifyHoldPayment from '../../pages/Accounts/VerifyHoldPayment';
import VerifyReceiptAgainstScrapSale from '../../pages/Accounts/VerifyReceiptAgainstScrapSale';
import VerifyRefund from '../../pages/Accounts/VerifyRefund';
import VerifyCentralDayBook from '../../pages/Accounts/VerifyCentralDayBook';
import VerifyBankAccounts from '../../pages/Accounts/VerifyBankAccounts';
import VerifyBankDeposit from '../../pages/Accounts/VerifyBankDeposit';
import VerifyBankTransfer from '../../pages/Accounts/VerifyBankTransfer';
import VerifyBankWithdrawal from '../../pages/Accounts/VerifyBankWithdrawal';
import VerifyCheque from '../../pages/Accounts/VerifyCheque';
import VerifyCloseMaster from '../../pages/Accounts/VerifyCloseMaster';
import VerifyOpenFD from '../../pages/Accounts/VerifyOpenFD';
import VerifyPartialFD from '../../pages/Accounts/VerifyPartialFD';
import VerifyFDInterest from '../../pages/Accounts/VerifyFDInterest';
import VerifyTermLoan from '../../pages/Accounts/VerifyTermLoan';
import VerifyTLAgency from '../../pages/Accounts/VerifyTLAgency';
import VerifyTLPayment from '../../pages/Accounts/VerifyTLPayment';
import VerifyUnsecuredLoan from '../../pages/Accounts/VerifyUnsecuredLoan';
import VerifyUnsLoanInterest from '../../pages/Accounts/VerifyUnsLoanInterest';
import VerifyShareCapital from '../../pages/Accounts/VerifyShareCapital';
import VerifyShareCreation from '../../pages/Accounts/VerifyShareCreation';
import ConfigVerification from '../../pages/Accounts/ConfigVerification';
import { getConfigVerificationKey } from '../../pages/Accounts/verificationConfigs';


// ============================================================================
// HELPER FUNCTIONS - Pure utility functions for route detection
// ============================================================================

const isStaffRegistrationVerification = (path) => {
    // Simple and direct path check - using lowercase
    const isMatch = path.includes('/hr/verifystaffregistration');

    if (isMatch) {
        console.log('✅ Staff Registration detected by path:', path);
    } else {
        console.log('❌ Staff Registration not detected. Path:', path);
    }

    return isMatch;
};

// Matches the Vendor Creation verification queue (/Purchase/VerifyVendor) only. The path check is
// anchored so it does NOT swallow /purchase/verifyvendorpayment, /purchase/verifyvendorpayablewriteoff
// or the CMS/BOE vendor payment paths, which all share the "verifyvendor" prefix.
const isVendorCreationVerification = (path, category, title, displayName, workflowType) => {
    const isMatch = /\/purchase\/verifyvendor(?:$|[?#/])/.test(path) ||
        category.includes('vendor verification') ||
        title.includes('vendor verification') ||
        displayName.includes('vendor verification') ||
        workflowType.includes('vendor verification');
    if (isMatch) {
        console.log('✅ Vendor Verification detected by:', { path, category, title, displayName, workflowType });
    } else {
        console.log('❌ Vendor Verification not detected. Path:', path);
    }
    return isMatch;
};

// Matches Bank vendor payment only — excludes Paytype=Cash paths
const isVendorPaymentVerification = (path, category, title, displayName, workflowType) => {
    // If the path explicitly requests Cash paytype, do NOT match here
    if (path.includes('paytype=cash')) return false;

    const pathMatches = [
        '/purchase/verifyvendorpayment?paytype=bank',
        '/vendorpayment/verifyvendorpayment',
        'verifyvendorpayment',
        'vendor payment'
    ];

    const isMatch = pathMatches.some(match => path.includes(match)) ||
        category.includes('vendor payment') ||
        category.includes('vendorpayment') ||
        title.includes('vendor payment') ||
        title.includes('vendorpayment') ||
        displayName.includes('vendor payment') ||
        displayName.includes('vendorpayment') ||
        workflowType.includes('vendor payment') ||
        workflowType.includes('vendorpayment');

    if (isMatch) {
        console.log('✅ Vendor Payment (Bank) detected by:', {
            path, category, title, displayName, workflowType
        });
    } else {
        console.log('❌ Vendor Payment (Bank) not detected. Details:', {
            path, category, title, displayName, workflowType
        });
    }

    return isMatch;
};

// Matches Cash vendor payment only — Paytype=Cash path
const isVendorCashPaymentVerification = (path) => {
    const isMatch = path.includes('/purchase/verifyvendorpayment?paytype=cash');
    if (isMatch) {
        console.log('✅ Vendor Payment (Cash) detected by path:', path);
    } else {
        console.log('❌ Vendor Payment (Cash) not detected. Path:', path);
    }
    return isMatch;
};

const isSupplierInvoiceVerification = (path, category, title, displayName, workflowType) => {
    const pathMatches = [
        '/vendorinvoice/verifysupplierinvoice',
        '/purchase/verifysupplierinvoice',
        'verifysupplierinvoice',
        'supplier invoice'
    ];

    const isMatch = pathMatches.some(match => path.includes(match)) ||
        category.includes('supplier invoice') ||
        category.includes('verifysupplierinvoice') ||
        title.includes('supplier invoice') ||
        title.includes('verifysupplierinvoice') ||
        displayName.includes('supplier invoice') ||
        displayName.includes('verifysupplierinvoice') ||
        workflowType.includes('supplier invoice') ||
        workflowType.includes('verifysupplierinvoice');

    if (isMatch) {
        console.log('✅ Supplier Invoice detected by:', {
            path, category, title, displayName, workflowType
        });
    } else {
        console.log('❌ Supplier Invoice not detected. Details:', {
            path, category, title, displayName, workflowType
        });
    }

    return isMatch;
};

const isSupplierPOVerification = (path, category, title, displayName, workflowType) => {
    // Never shadow the separate Supplier PO Amendment verification page — its
    // path/title also contains "supplier po", so it must be excluded here.
    const isAmendPage = path.includes('amend') || category.includes('amend') ||
        title.includes('amend') || displayName.includes('amend') || workflowType.includes('amend');
    if (isAmendPage) return false;

    const pathMatches = [
        '/supplierpo/verifysupplierpo',
        '/purchase/verifysupplierpo',
        'verifysupplierpo',
        'supplier po'
    ];

    const isMatch = pathMatches.some(match => path.includes(match)) ||
        category.includes('supplier po') ||
        category.includes('verifysupplierpo') ||
        title.includes('supplier po') ||
        title.includes('verifysupplierpo') ||
        displayName.includes('supplier po') ||
        displayName.includes('verifysupplierpo') ||
        workflowType.includes('supplier po') ||
        workflowType.includes('verifysupplierpo');

    if (isMatch) {
        console.log('✅ Supplier PO detected by:', {
            path, category, title, displayName, workflowType
        });
    } else {
        console.log('❌ Supplier PO not detected. Details:', {
            path, category, title, displayName, workflowType
        });
    }

    return isMatch;
};

const isSupplierPOAmendVerification = (path, category, title, displayName, workflowType) => {
    const pathMatches = [
        '/supplierpo/verifysupplierpoamend',
        '/purchase/verifysupplierpoamend',
        'verifysupplierpoamend',
    ];

    const isMatch = pathMatches.some(match => path.includes(match)) ||
        (category.includes('supplier po') && category.includes('amend')) ||
        category.includes('verifysupplierpoamend') ||
        (title.includes('supplier po') && title.includes('amend')) ||
        title.includes('verifysupplierpoamend') ||
        (displayName.includes('supplier po') && displayName.includes('amend')) ||
        displayName.includes('verifysupplierpoamend') ||
        (workflowType.includes('supplier po') && workflowType.includes('amend')) ||
        workflowType.includes('verifysupplierpoamend');

    if (isMatch) {
        console.log('✅ Supplier PO Amend detected by:', {
            path, category, title, displayName, workflowType
        });
    } else {
        console.log('❌ Supplier PO Amend not detected. Details:', {
            path, category, title, displayName, workflowType
        });
    }

    return isMatch;
};

const isSPPOVerification = (path, category, title, displayName, workflowType) => {
    // ✅ Exact path matches for SPPO Verification only
    const pathMatches = [
        '/sppo/verifysppo',
        '/purchase/verifysppo'  // Without 'close'
    ];

    // ✅ Check for exact path match first (most reliable)
    const exactPathMatch = pathMatches.some(match => path === match);

    // ✅ If not exact match, check if path contains the pattern but NOT 'close'
    // …and NOT 'invoice': /purchase/verifysppoinvoice (SP Invoice) has its own config page.
    const partialPathMatch = pathMatches.some(match => path.includes(match)) && !path.includes('close') && !path.includes('invoice');

    const isMatch = exactPathMatch ||
        partialPathMatch ||
        (category.includes('newsppo') && !category.includes('close')) ||
        (title.includes('newsppo') && !title.includes('close')) ||
        (displayName.includes('newsppo') && !displayName.includes('close')) ||
        (workflowType.includes('sppoverify') && !workflowType.includes('close'));

    if (isMatch) {
        console.log('✅ SPPO Verification detected by:', {
            path, category, title, displayName, workflowType
        });
    } else {
        console.log('❌ SPPO Verification not detected. Details:', {
            path, category, title, displayName, workflowType
        });
    }

    return isMatch;
};

const isCostCenterApproval = (path, category, title, displayName, workflowType) => {
    const pathMatches = [
        '/costcenter/approvecostcenter',
        '/accounts/approvecostcenter',
        'approvecostcenter',
        'cost center approval',
        'costcenterapproval'
    ];
    const isMatch = pathMatches.some(match => path.includes(match)) ||
        category.includes('cost center approval') ||
        category.includes('costcenterapproval') ||
        title.includes('cost center approval') ||
        title.includes('costcenterapproval') ||
        displayName.includes('cost center approval') ||
        displayName.includes('costcenterapproval') ||
        workflowType.includes('cost center approval') ||
        workflowType.includes('costcenterapproval');
    if (isMatch) {
        console.log('✅ Cost Center Approval detected by:', {
            path, category, title, displayName, workflowType
        });
    } else {
        console.log('❌ Cost Center Approval not detected. Details:', {
            path, category, title, displayName, workflowType
        });
    }
    return isMatch;
};

const isGeneralInvoiceApproval = (path, category, title, displayName, workflowType) => {
    const pathMatches = [
        '/accounts/approvegeneralinvoice',
        '/generalinvoice/approvegeneralinvoice',
        '/invoice/approvegeneralinvoice',
        'approvegeneralinvoice',
        'general invoice approval',
        'generalinvoiceapproval',
        'general invoice',
        'generalinvoice'
    ];

    const isMatch = pathMatches.some(match => path.includes(match)) ||
        category.includes('general invoice approval') ||
        category.includes('generalinvoiceapproval') ||
        category.includes('general invoice') ||
        category.includes('generalinvoice') ||
        title.includes('general invoice approval') ||
        title.includes('generalinvoiceapproval') ||
        title.includes('general invoice') ||
        title.includes('generalinvoice') ||
        displayName.includes('general invoice approval') ||
        displayName.includes('generalinvoiceapproval') ||
        displayName.includes('general invoice') ||
        displayName.includes('generalinvoice') ||
        workflowType.includes('general invoice approval') ||
        workflowType.includes('generalinvoiceapproval') ||
        workflowType.includes('general invoice') ||
        workflowType.includes('generalinvoice');

    if (isMatch) {
        console.log('✅ General Invoice Approval detected by:', {
            path, category, title, displayName, workflowType
        });
    } else {
        console.log('❌ General Invoice Approval not detected. Details:', {
            path, category, title, displayName, workflowType
        });
    }

    return isMatch;
};

const isCCBudgetAmendmentVerification = (path, category, title, displayName, workflowType) => {
    const pathMatches = [
        '/budget/verifyccbudgetamendment',
        '/accounts/verifyccbudgetamendment',
        '/accountsapproval/verifyccamendbudget',
        'verifyccbudgetamendment',
        'cc budget amendment'
    ];
    const isMatch = pathMatches.some(match => path.includes(match)) ||
        category.includes('cc budget amendment') ||
        category.includes('verifyccbudgetamendment') ||
        title.includes('cc budget amendment') ||
        title.includes('verifyccbudgetamendment') ||
        displayName.includes('cc budget amendment') ||
        displayName.includes('cost center budget amend(pcc)') ||
        workflowType.includes('cc budget amendment') ||
        workflowType.includes('verifyccbudgetamendment');
    if (isMatch) {
        console.log('✅ CC Budget Amendment detected by:', {
            path, category, title, displayName, workflowType
        });
    } else {
        console.log('❌ CC Budget Amendment not detected. Details:', {
            path, category, title, displayName, workflowType
        });
    }
    return isMatch;
};

const isDCABudgetAmendmentVerification = (path, category, title, displayName, workflowType) => {
    const pathMatches = [
        '/AccountsApproval/VerifyDCABudgetAmend',
        '/accountsapproval/verifydcabudgetamend',
        '/accountsapproval/verifydcaamendbudget',
        'verifydcabudgetamendment',
        'dca budget amendment'
    ];
    const isMatch = pathMatches.some(match => path.includes(match)) ||
        category.includes('dca budget amendment') ||
        category.includes('/accountsapproval/verifydcabudgetamend') ||
        title.includes('Account Head Amend') ||
        title.includes('account head amend') ||
        displayName.includes('dca budget amendment') ||
        displayName.includes('account head amend(pcc)') ||
        workflowType.includes('dca budget amendment') ||
        workflowType.includes('verifydcabudgetamendment');
    if (isMatch) {
        console.log('✅ DCA Budget Amendment detected by:', {
            path, category, title, displayName, workflowType
        });
    } else {
        console.log('❌ DCA Budget Amendment not detected. Details:', {
            path, category, title, displayName, workflowType
        });
    }
    return isMatch;
};

const isClientPOVerification = (path, category, title, displayName, workflowType) => {
    // Client PO Amend (/AccountsApproval/VerifyClientPOAmend, category "Amend Client PO") has its own config page —
    // the loose "client po" / "verifyclientpo" checks below would otherwise swallow it.
    if (path.includes('verifyclientpoamend') || category.includes('amend client po')) return false;
    const pathMatches = [
        '/clientpo/verifyclientpo',
        '/sales/verifyclientpo',
        'verifyclientpo',
        'client po'
    ];
    const isMatch = pathMatches.some(match => path.includes(match)) ||
        category.includes('client po') ||
        category.includes('verifyclientpo') ||
        title.includes('client po') ||
        title.includes('verifyclientpo') ||
        displayName.includes('client po') ||
        displayName.includes('verifyclientpo') ||
        workflowType.includes('client po') ||
        workflowType.includes('verifyclientpo');
    if (isMatch) {
        console.log('✅ Client PO Verification detected by:', {
            path, category, title, displayName, workflowType
        });
    } else {
        console.log('❌ Client PO Verification not detected. Details:', {
            path, category, title, displayName, workflowType
        });
    }
    return isMatch;
};

// Must be matched before isMiscInvoiceVerification, whose 'verifymisc' substring check and
// 'miscellaneous' category/title check would otherwise also swallow this path.
const isMiscPaymentVerification = (path, category, title, displayName, workflowType) => {
    const pathMatches = [
        '/accountsapproval/verifymiscpayment',
        'verifymiscpayment',
        'miscellaneous payment',
        'misc payment',
        'miscpayment',
    ];
    return pathMatches.some(match => path.includes(match)) ||
        category.includes('misc payment') || category.includes('miscpayment') ||
        title.includes('misc payment') || title.includes('miscpayment') ||
        displayName.includes('misc payment') || displayName.includes('miscpayment') ||
        workflowType.includes('misc payment') || workflowType.includes('miscpayment');
};

const isMiscInvoiceVerification = (path, category, title, displayName, workflowType) => {
    const pathMatches = [
        '/accountsapproval/verifymisc',
        'verifymisc',
        'miscellaneous invoice',
        'misc invoice',
        'miscinvoice',
    ];
    return pathMatches.some(match => path.includes(match)) ||
        category.includes('misc invoice') || category.includes('miscinvoice') || category.includes('miscellaneous') ||
        title.includes('misc invoice') || title.includes('miscinvoice') || title.includes('miscellaneous') ||
        displayName.includes('misc invoice') || displayName.includes('miscinvoice') || displayName.includes('miscellaneous') ||
        workflowType.includes('misc invoice') || workflowType.includes('miscinvoice');
};

// Must be matched before the generic "advance"/HR catch-alls further down, which would
// otherwise swallow this path since it also contains the substring "advance".
const isClientRecievableVerification = (path, category, title, displayName, workflowType) => {
    const pathMatches = ['accountsapproval/verifyclientrecievable', 'verifyclientrecievable', 'client receipt verification'];
    return pathMatches.some(match => path.includes(match)) ||
        category.includes('client receipt') || category.includes('clientrecievable') ||
        title.includes('client receipt') || title.includes('clientrecievable') ||
        displayName.includes('client receipt') || displayName.includes('clientrecievable') ||
        workflowType.includes('clientrecievable');
};

const isAdvancePaymentVerification = (path, category, title, displayName, workflowType) => {
    const pathMatches = ['accountsapproval/verifyadvancepayment', 'verifyadvancepayment', 'advance payment verification'];
    return pathMatches.some(match => path.includes(match)) ||
        category.includes('advance payment verification') || category.includes('verifyadvancepayment') ||
        title.includes('advance payment verification') || title.includes('verifyadvancepayment') ||
        displayName.includes('advance payment verification') || displayName.includes('verifyadvancepayment') ||
        workflowType.includes('advancepaymentverification');
};

const isRetentionPaymentVerification = (path, category, title, displayName, workflowType) => {
    const pathMatches = ['accountsapproval/verifyretentionpayment', 'verifyretentionpayment', 'retention payment verification'];
    return pathMatches.some(match => path.includes(match)) ||
        category.includes('retention payment') || category.includes('verifyretentionpayment') ||
        title.includes('retention payment') || title.includes('verifyretentionpayment') ||
        displayName.includes('retention payment') || displayName.includes('verifyretentionpayment') ||
        workflowType.includes('retentionpayment');
};

const isHoldPaymentVerification = (path, category, title, displayName, workflowType) => {
    const pathMatches = ['accountsapproval/verifyholdpayment', 'verifyholdpayment', 'hold payment verification'];
    return pathMatches.some(match => path.includes(match)) ||
        category.includes('hold payment') || category.includes('verifyholdpayment') ||
        title.includes('hold payment') || title.includes('verifyholdpayment') ||
        displayName.includes('hold payment') || displayName.includes('verifyholdpayment') ||
        workflowType.includes('holdpayment');
};

const isReceiptAgainstScrapSaleVerification = (path, category, title, displayName, workflowType) => {
    const pathMatches = [
        'accountsapproval/verifyreceiptagainstscrapsale',
        'verifyreceiptagainstscrapsale',
        'receipt against scrap sale',
    ];
    return pathMatches.some(match => path.includes(match)) ||
        category.includes('receipt against scrap sale') || category.includes('scrap sale receipt') ||
        title.includes('receipt against scrap sale') || title.includes('scrap sale receipt') ||
        displayName.includes('receipt against scrap sale') || displayName.includes('scrap sale receipt') ||
        workflowType.includes('receiptagainstscrapsale');
};

const isRefundVerification = (path, category, title, displayName, workflowType) => {
    const pathMatches = [
        'accountsapproval/verifyrefund',
        'verifyrefund',
    ];
    return pathMatches.some(match => path.includes(match)) ||
        category.includes('refund') ||
        title.includes('refund') ||
        displayName.includes('refund') ||
        workflowType.includes('refund');
};

const isCentralDayBookVerification = (path, category, title, displayName, workflowType) => {
    const pathMatches = [
        'accountsapproval/verifycentraldaybook',
        'verifycentraldaybook',
        'central day book',
    ];
    return pathMatches.some(match => path.includes(match)) ||
        category.includes('central day book') || category.includes('centraldaybook') ||
        title.includes('central day book') || title.includes('centraldaybook') ||
        displayName.includes('central day book') || displayName.includes('centraldaybook') ||
        workflowType.includes('centraldaybook');
};

const isLostDamagedItemsVerification = (path, category, title, displayName, workflowType) => {
    const pathMatches = [
        '/stock/verifylostdamageditems',
        '/Purchase/VerifyLostorDamagedItems',
        '/purchase/verifylostordamageditems',
        '/stock/lostordamageditemsverification',
        '/stock/lostdamageditemsverification',
        'Lost or Scrapped Items ',
        'lost or scrapped items',
    ];
    const isMatch = pathMatches.some(match => path.includes(match)) ||
        category.includes('lost damaged items') ||
        category.includes('verifylostdamageditems') ||
        title.includes('lost damaged items') ||
        title.includes('verifylostdamageditems') ||
        displayName.includes('lost damaged items') ||
        displayName.includes('verifylostdamageditems') ||
        workflowType.includes('lost damaged items') ||
        workflowType.includes('verifylostdamageditems');
    if (isMatch) {
        console.log('✅ Lost Damaged Items Verification detected by:', {
            path, category, title, displayName, workflowType
        });
    } else {
        console.log('❌ Lost Damaged Items Verification not detected. Details:', {
            path, category, title, displayName, workflowType
        });
    }
    return isMatch;
};

const isDailyIssueVerification = (path, category, title, displayName, workflowType) => {
    const pathMatches = [
        '/stock/verifydailyissue',
        '/purchase/verifydailyissue',
        'verifydailyissue',
        'daily issue'
    ];;
    const isMatch = pathMatches.some(match => path.includes(match)) ||
        category.includes('daily issue') ||
        category.includes('verifydailyissue') ||
        title.includes('daily issue') ||
        title.includes('verifydailyissue') ||
        displayName.includes('daily issue') ||
        displayName.includes('verifydailyissue') ||
        workflowType.includes('daily issue') ||
        workflowType.includes('verifydailyissue');
    if (isMatch) {
        console.log('✅ Daily Issue Verification detected by:', {
            path, category, title, displayName, workflowType
        });
    } else {
        console.log('❌ Daily Issue Verification not detected. Details:', {
            path, category, title, displayName, workflowType
        });
    }
    return isMatch;
};

const isScrapSaleVerification = (path, category, title, displayName, workflowType) => {
    // Client Scrap Sale Invoice (/AccountsApproval/VerifyClientScrapSaleInvoice, category "Scrap Sale Invoice") is a
    // different workflow with its own config page — the loose "scrap sale" checks below would otherwise swallow it.
    if (path.includes('scrapsaleinvoice') || category.includes('scrap sale invoice')) return false;
    const pathMatches = [
        '/stock/verifyscrapsale',
        '/purchase/verifyscrapsale',
        'verifyscrapsale',
        'scrap sale'
    ];;
    const isMatch = pathMatches.some(match => path.includes(match)) ||
        category.includes('scrap sale') ||
        category.includes('verifyscrapsale') ||
        title.includes('scrap sale') ||
        title.includes('verifyscrapsale') ||
        displayName.includes('scrap sale') ||
        displayName.includes('verifyscrapsale') ||
        workflowType.includes('scrap sale') ||
        workflowType.includes('verifyscrapsale');
    if (isMatch) {
        console.log('✅ Scrap Sale Verification detected by:', {
            path, category, title, displayName, workflowType
        });
    } else {
        console.log('❌ Scrap Sale Verification not detected. Details:', {
            path, category, title, displayName, workflowType
        });
    }
    return isMatch;
};

const isSPPOCloseVerification = (path, category, title, displayName, workflowType) => {
    // ✅ Exact path matches for SPPO Close Verification
    const pathMatches = [
        '/purchase/verifysppoclose',
        '/purchase/verifysppoclose?closetype=performing',
        '/purchase/verifysppoclose?closetype=nonperforming',
        '/sppo/verifysppoclose'
    ];

    // ✅ Check for exact path match (without query params) OR with query params
    const basePathMatch = path.startsWith('/purchase/verifysppoclose') ||
        path.startsWith('/sppo/verifysppoclose');

    const exactPathMatch = pathMatches.some(match => path === match || path.startsWith(match));

    const isMatch = basePathMatch ||
        exactPathMatch ||
        path.includes('verifysppoclose') ||
        category.includes('sppo close') ||
        title.includes('sppo close verification') ||
        displayName.includes('sppo close verification') ||
        workflowType.includes('sppoclose');

    if (isMatch) {
        console.log('✅ SPPO Close Verification detected by:', {
            path, category, title, displayName, workflowType
        });
    } else {
        console.log('❌ SPPO Close Verification not detected. Details:', {
            path, category, title, displayName, workflowType
        });
    }

    return isMatch;
};

const isSPPOAmendVerification = (path, category, title, displayName, workflowType) => {
    const pathMatches = [
        '/sppo/verifysppoamend',
        '/purchase/verifysppoamend',
        'verifysppoamend',
        'sppo amend'
    ];
    const isMatch = pathMatches.some(match => path.includes(match)) ||
        category.includes('sppo amend') ||
        category.includes('verifysppoamend') ||
        title.includes('sppo amend') ||
        title.includes('verifysppoamend') ||
        displayName.includes('sppo amend') ||
        displayName.includes('verifysppoamend') ||
        workflowType.includes('sppo amend') ||
        workflowType.includes('verifysppoamend');
    if (isMatch) {
        console.log('✅ SPPO Amend Verification detected by:', {
            path, category, title, displayName, workflowType
        });
    } else {
        console.log('❌ SPPO Amend Verification not detected. Details:', {
            path, category, title, displayName, workflowType
        });
    }
    return isMatch;
};

const isExcelAttendanceVerification = (path, category, title, displayName, workflowType) => {
    const pathMatches = [
        '/hr/verifyexcelattendance',    
        '/hr/verifyexcelattendanceinbox',
        'verifyexcelattendance',
        'excel attendance'
    ];
    const isMatch = pathMatches.some(match => path.includes(match)) ||
        category.includes('excel attendance') ||
        category.includes('verifyexcelattendance') ||
        title.includes('excel attendance') ||
        title.includes('verifyexcelattendance') ||
        displayName.includes('excel attendance') ||
        displayName.includes('verifyexcelattendance') ||
        workflowType.includes('excel attendance') ||
        workflowType.includes('verifyexcelattendance');     
    if (isMatch) {
        console.log('✅ Excel Attendance Verification detected by:', {
            path, category, title, displayName, workflowType
        });
    } else {
        console.log('❌ Excel Attendance Verification not detected. Details:', {
            path, category, title, displayName, workflowType
        });
    }
    return isMatch;
};

const isDailyAttendanceVerification = (path, category, title, displayName, workflowType) => {
    const pathMatches = [
        '/HR/VerifyStaffAttendance?Type=Staff', 
        '/hr/verifystaffattendance',
        'verifystaffattendance',
        'staff daily attendance'
    ];  
    const isMatch = pathMatches.some(match => path.includes(match)) ||
        category.includes('/HR/VerifyStaffAttendance?Type=Staff') ||
        category.includes('/HR/VerifyStaffAttendance') ||
        title.includes('Staff Attendance') ||
        title.includes('verifystaffattendance') ||
        displayName.includes('staff daily attendance') ||
        displayName.includes('verifystaffattendance') ||
        workflowType.includes('staff daily attendance') ||
        workflowType.includes('verifystaffattendance');
    if (isMatch) {
        console.log('✅ Staff Daily Attendance Verification detected by:', {
            path, category, title, displayName, workflowType
        });
    } else {
        console.log('❌ Staff Daily Attendance Verification not detected. Details:', {
            path, category, title, displayName, workflowType
        });
    }   
    return isMatch;
};

const isLabourObjectivesGoalsVerification = (path) => {
    // Simple and direct path check - using lowercase
    const isMatch = path.includes('/HR/VerifyLBObjectivesGoals') || path.includes('/hr/verifylbobjectivesgoals');

    if (isMatch) {
        console.log('✅ Labour Objectives & Goals detected by path:', path);
    } else {
        console.log('❌ Labour Objectives & Goals not detected. Path:', path);
    }

    return isMatch;
};

const isStaffObjectivesGoalsVerification = (path) => {
    // Simple and direct path check - using lowercase
    const isMatch = path.includes('/HR/VerifyObjectivesAndGoals') || path.includes('/hr/verifyobjectivesandgoals');

    if (isMatch) {
        console.log('✅ Staff Objectives & Goals detected by path:', path);
    } else {
        console.log('❌ Staff Objectives & Goals not detected. Path:', path);
    }
    return isMatch;
};

const isEmployeeCTCVerification = (path) => {
    // Simple and direct path check - using lowercase
    const isMatch = path.includes('/HR/VerifyPayRollStructureNew') || path.includes('/hr/verifypayrollstructurenew'); 
    if (isMatch) {
        console.log('✅ Employee CTC detected by path:', path);
    } else {
        console.log('❌ Employee CTC not detected. Path:', path);
    }   
    return isMatch;
};

const isLabourCTCVerification = (path) => {
    const isMatch = path.includes('/HR/VerifyNewLabourCTC') || path.includes('/hr/verifynewlabourctc')
        || path.includes('/HR/VerifyLabourCTC') || path.includes('/hr/verifylabourctc');
    if (isMatch) {
        console.log('✅ Labour CTC detected by path:', path);
    } else {
        console.log('❌ Labour CTC not detected. Path:', path);
    }
    return isMatch;
};

const isLabourPayrollVerification = (path) => {
    const isMatch = path.includes('/HR/VerifyLabourPayRoll') || path.includes('/hr/verifylabourpayroll') || path.includes('/HR/VerifyLabourPayroll') || path.includes('/hr/approvelabourpayroll');
    if (isMatch) {
        console.log('✅ Labour Payroll detected by path:', path);
    } else {
        console.log('❌ Labour Payroll not detected. Path:', path);
    }
    return isMatch;
};

const isLabourPayRevisionVerification = (path) => {
    // Simple and direct path check - using lowercase
    const isMatch = path.includes('/HR/VerifyLBPayRevision') || path.includes('/hr/verifylbpayrevision');
    if (isMatch) {
        console.log('✅ Labour Pay Revision detected by path:', path);
    } else {
        console.log('❌ Labour Pay Revision not detected. Path:', path);
    }
    return isMatch;
};


const isStaffPayRevisionVerification = (path) => {
    // Simple and direct path check - using lowercase
    const isMatch = path.includes('/HR/VerifyPayRevision') || path.includes('/hr/verifypayrevision'); 
    if (isMatch) {
        console.log('✅ Staff Pay Revision detected by path:', path);
    }
    else {
        console.log('❌ Staff Pay Revision not detected. Path:', path);
    }
    return isMatch;
};

const isEmployeeLeaveRequestVerification = (path) => {
    // Simple and direct path check - using lowercase
    const isMatch = path.includes('/HR/VerifyHRLeaveRequest') || path.includes('/hr/verifyhrleaverequest'); 
    if (isMatch) {
        console.log('✅ Employee Leave Request detected by path:', path);
    } else {
        console.log('❌ Employee Leave Request not detected. Path:', path);
    }
    return isMatch;
};
const isDividendDeclarationVerification = (path) => {
    // Simple and direct path check - using lowercase
    const isMatch = path.includes('/shares/dividenddeclarationverification') || path.includes('/Shares/DividendDeclarationVerification');

    if (isMatch) {
        console.log('✅ Dividend Declaration Verification detected by path:', path);
    } else {
        console.log('❌ Dividend Declaration Verification not detected. Path:', path);
    }
    return isMatch;
};

const isDividendDistributionVerification = (path) => {
    // Simple and direct path check - using lowercase
    const isMatch = path.includes('/shares/dividenddistributionverification') || path.includes('/Shares/DividendDistributionVerification'); 
    if (isMatch) {
        console.log('✅ Dividend Distribution Verification detected by path:', path);
    } else {
        console.log('❌ Dividend Distribution Verification not detected. Path:', path);
    }
    return isMatch;
};

const isDividendBankPaymentVerification = (path) => {
    // Simple and direct path check - using lowercase
    const isMatch = path.includes('/shares/DividendPaymentVerification') || path.includes('/Shares/DividendPaymentVerification')|| path.includes('/shares/dividendpaymentverification') || path.includes('/shares/dividendbankpaymentverification');

    if (isMatch) {
        console.log('✅ Dividend Bank Payment Verification detected by path:', path);
    } else {
        console.log('❌ Dividend Bank Payment Verification not detected. Path:', path); 
    }
    return isMatch;
};

const isStaffCMSPayVerification = (path) => {
    // Simple and direct path check - using lowercase
    const isMatch = path.includes('/hr/verifycmspaygeneration') || path.includes('/HR/VerifyCMSPayGeneration');
    if (isMatch) {
        console.log('✅ Staff CMS Pay Verification detected by path:', path);
    } else {
        console.log('❌ Staff CMS Pay Verification not detected. Path:', path);
    }
    return isMatch;
};

const isStaffPayrollVerification = (path) => {
    // Simple and direct path check - using lowercase
    const isMatch = path.includes('/hr/verifyccpayroll') || path.includes('/HR/VerifyCCPayRoll');
    if (isMatch) {
        console.log('✅ Staff Payroll Verification detected by path:', path);
    } else {
        console.log('❌ Staff Payroll Verification not detected. Path:', path);
    }
    return isMatch;
};

const isSalaryDeductionArearVerification = (path) => {
    
    const isMatch = path.includes('/hr/verifysalarydeduction') || path.includes('/HR/VerifySalaryDeduction');
    if (isMatch) {
        console.log('✅ Salary Deduction Arear Verification detected by path:', path);
    } else {
        console.log('❌ Salary Deduction Arear Verification not detected. Path:', path);
    }
    return isMatch;
};
const isEmployeeTransferVerification = (path) => {
    const isMatch = path.includes('/hr/verifyemployeetransfer') || path.includes('/HR/VerifyEmployeeTransfer');
    if (isMatch) {
        console.log('✅ Employee Transfer Verification detected by path:', path);
    } else {
        console.log('❌ Employee Transfer Verification not detected. Path:', path);
    }
    return isMatch;
};

const isCCCashTransferVerification = (path, category, title, displayName, workflowType) => {
    const isMatch =
        path.includes('cccashtransfer') ||
        path.includes('cc cash transfer') ||
        path.includes('verifycccashtransfer') ||
        category.includes('cccashtransfer') ||
        category.includes('cc cash transfer') ||
        title.includes('cccashtransfer') ||
        title.includes('cc cash transfer') ||
        displayName.includes('cccashtransfer') ||
        displayName.includes('cc cash transfer') ||
        workflowType.includes('cccashtransfer') ||
        workflowType.includes('cc cash transfer');

    if (isMatch) {
        console.log('✅ CC Cash Transfer detected by:', { path, category, title, displayName, workflowType });
    } else {
        console.log('❌ CC Cash Transfer not detected. Path:', path);
    }
    return isMatch;
};

const isCashVoucherVerification = (path, category, title, displayName, workflowType) => {
    const pathMatches = [
        '/accounts/verifycashvoucher',
        '/accountsapproval/verifygeneralpayablebycash',
        '/accountsapproval/verifycashvoucher',
        'verifycashvoucher',
        'cashvoucher',
        'cash voucher',
        'generalpayablebycash',
        'cashpayment',
        'cash payment',
    ];
    const isMatch = pathMatches.some(match => path.includes(match)) ||
        category.includes('cash voucher') ||
        category.includes('cashvoucher') ||
        category.includes('generalpayablebycash') ||
        title.includes('cash voucher') ||
        title.includes('cashvoucher') ||
        displayName.includes('cash voucher') ||
        displayName.includes('cashvoucher') ||
        workflowType.includes('cash voucher') ||
        workflowType.includes('cashvoucher');
    if (isMatch) {
        console.log('✅ Cash Voucher Verification detected by:', { path, category, title, displayName, workflowType });
    } else {
        console.log('❌ Cash Voucher Verification not detected. Details:', { path, category, title, displayName, workflowType });
    }
    return isMatch;
};

const isCCClosingVerification = (path, category, title, displayName, workflowType) => {
    const isMatch =
        path.includes('ccclosing') ||
        path.includes('cc closing') ||
        path.includes('verifyccclosing') ||
        path.includes('ccsuspend') ||
        path.includes('cc suspend') ||
        category.includes('ccclosing') ||
        category.includes('cc closing') ||
        title.includes('ccclosing') ||
        title.includes('cc closing') ||
        displayName.includes('ccclosing') ||
        displayName.includes('cc closing') ||
        workflowType.includes('ccclosing') ||
        workflowType.includes('cc closing');

    if (isMatch) {
        console.log('✅ CC Closing detected by:', { path, category, title, displayName, workflowType });
    } else {
        console.log('❌ CC Closing not detected. Path:', path);
    }
    return isMatch;
};

const isLoadWalletVerification = (path, category, title, displayName, workflowType) => {
    const isMatch =
        path.includes('loadwallet') ||
        path.includes('load wallet') ||
        path.includes('verifyloadwallet') ||
        category.includes('loadwallet') ||
        category.includes('load wallet') ||
        title.includes('loadwallet') ||
        title.includes('load wallet') ||
        displayName.includes('loadwallet') ||
        displayName.includes('load wallet') ||
        workflowType.includes('loadwallet') ||
        workflowType.includes('load wallet');

    if (isMatch) {
        console.log('✅ Load Wallet detected by:', { path, category, title, displayName, workflowType });
    } else {
        console.log('❌ Load Wallet not detected. Path:', path);
    }
    return isMatch;
};

const isLabourCMSPayVerification = (path, category, title, displayName, workflowType) => {
    const pathMatches = [
        '/hr/verifylabourcmspay',
        '/hr/verifylabourcms',
        'verifylabourcmspay',
        'labour cms',
        'labourcms',
    ];
    const isMatch = pathMatches.some(match => path.includes(match)) ||
        category.includes('labour cms') ||
        category.includes('labourcms') ||
        title.includes('labour cms') ||
        title.includes('labourcms') ||
        displayName.includes('labour cms') ||
        displayName.includes('labourcms') ||
        workflowType.includes('labour cms') ||
        workflowType.includes('labourcms');
    if (isMatch) {
        console.log('✅ Labour CMS Pay Verification detected by:', { path, category, title, displayName, workflowType });
    } else {
        console.log('❌ Labour CMS Pay Verification not detected. Path:', path);
    }
    return isMatch;
};

const isWorkerStaffRegVerification = (path, category, title, displayName, workflowType) => {
    const pathMatches = [
        '/hr/verifyworkerstaffreg',
        'verifyworkerstaffreg',
        'worker staff reg',
        'workerstaffreg',
    ];
    const isMatch = pathMatches.some(match => path.includes(match)) ||
        category.includes('worker staff reg') ||
        category.includes('workerstaffreg') ||
        title.includes('worker staff reg') ||
        title.includes('workerstaffreg') ||
        displayName.includes('worker staff reg') ||
        displayName.includes('workerstaffreg') ||
        workflowType.includes('worker staff reg') ||
        workflowType.includes('workerstaffreg');
    if (isMatch) {
        console.log('✅ Worker Staff Reg Verification detected by:', { path, category, title, displayName, workflowType });
    } else {
        console.log('❌ Worker Staff Reg Verification not detected. Path:', path);
    }
    return isMatch;
};

const isLabourBankChangeVerification = (path, category, title, displayName, workflowType) => {
    const pathMatches = [
        '/hr/verifylabourbankchange',
        '/hr/approvelabourbankchange',
        'verifylabourbankchange',
        'labour bank change',
        'labourbankchange',
    ];
    const isMatch = pathMatches.some(match => path.includes(match)) ||
        category.includes('labour bank change') ||
        category.includes('labourbankchange') ||
        title.includes('labour bank change') ||
        title.includes('labourbankchange') ||
        displayName.includes('labour bank change') ||
        displayName.includes('labourbankchange') ||
        workflowType.includes('labour bank change') ||
        workflowType.includes('labourbankchange');
    if (isMatch) {
        console.log('✅ Labour Bank Change Verification detected by:', { path, category, title, displayName, workflowType });
    } else {
        console.log('❌ Labour Bank Change Verification not detected. Path:', path);
    }
    return isMatch;
};

const isEmpBankChangeVerification = (path, category, title, displayName, workflowType) => {
    const pathMatches = [
        '/hr/verifyeditempbank',
        '/hr/verifyempbankchange',
        '/hr/approveempbankchange',
        'verifyeditempbank',
        'employee bank change',
        'empbankchange',
    ];
    const isMatch = pathMatches.some(match => path.includes(match)) ||
        category.includes('employee bank change') ||
        category.includes('empbankchange') ||
        title.includes('employee bank change') ||
        title.includes('empbankchange') ||
        displayName.includes('employee bank change') ||
        displayName.includes('empbankchange') ||
        workflowType.includes('employee bank change') ||
        workflowType.includes('empbankchange');
    if (isMatch) {
        console.log('✅ Employee Bank Change Verification detected by:', { path, category, title, displayName, workflowType });
    } else {
        console.log('❌ Employee Bank Change Verification not detected. Path:', path);
    }
    return isMatch;
};

const isBulkWorkerVerification = (path, category, title, displayName, workflowType) => {
    const pathMatches = [
        '/hr/verifybulkworker',
        '/hr/approvebulkworker',
        'verifybulkworker',
        'bulk worker',
        'bulkworker',
    ];
    const isMatch = pathMatches.some(match => path.includes(match)) ||
        category.includes('bulk worker') ||
        category.includes('bulkworker') ||
        title.includes('bulk worker') ||
        title.includes('bulkworker') ||
        displayName.includes('bulk worker') ||
        displayName.includes('bulkworker') ||
        workflowType.includes('bulk worker') ||
        workflowType.includes('bulkworker');
    if (isMatch) {
        console.log('✅ Bulk Worker Verification detected by:', { path, category, title, displayName, workflowType });
    } else {
        console.log('❌ Bulk Worker Verification not detected. Path:', path);
    }
    return isMatch;
};

const isLabourTypeChangeVerification = (path, category, title, displayName, workflowType) => {
    const pathMatches = [
        '/hr/verifylabourtypechange',
        '/hr/labourtypechange',
        'verifylabourtypechange',
        'labour type change',
        'labourtypechange',
    ];
    const isMatch = pathMatches.some(match => path.includes(match)) ||
        category.includes('labour type change') ||
        category.includes('labourtypechange') ||
        title.includes('labour type change') ||
        title.includes('labourtypechange') ||
        displayName.includes('labour type change') ||
        displayName.includes('labourtypechange') ||
        workflowType.includes('labour type change') ||
        workflowType.includes('labourtypechange');
    if (isMatch) {
        console.log('✅ Labour Type Change Verification detected by:', { path, category, title, displayName, workflowType });
    } else {
        console.log('❌ Labour Type Change Verification not detected. Path:', path);
    }
    return isMatch;
};

const isItemCodeVerification = (path, category, title, displayName, workflowType) => {
    // Item Code Updation (/Purchase/VerifyItemCodeUpdation, category "Item Code Updation") has its own config page with
    // its own queue/approve endpoints — the loose "itemcode" / "item code" checks below would otherwise swallow it.
    if (path.includes('verifyitemcodeupdation') || category.includes('item code updation')) return false;
    const pathMatches = [
        '/purchase/verifyitemcode',
        '/purchase/verifyitemcodecreation',
        'verifyitemcode',
        'item code creation',
        'itemcodecreation',
        'itemcode',
    ];
    const isMatch = pathMatches.some(match => path.includes(match)) ||
        category.includes('item code') ||
        category.includes('itemcode') ||
        title.includes('item code') ||
        title.includes('itemcode') ||
        displayName.includes('item code') ||
        displayName.includes('itemcode') ||
        workflowType.includes('item code') ||
        workflowType.includes('itemcode');
    if (isMatch) {
        console.log('✅ Item Code Verification detected by:', { path, category, title, displayName, workflowType });
    } else {
        console.log('❌ Item Code Verification not detected. Path:', path);
    }
    return isMatch;
};

const isLabourExitVerification = (path, category, title, displayName, workflowType) => {
    const pathMatches = [
        '/hr/verifylbexit',
        '/hr/verifylaborexit',
        '/hr/verifylabourexit',
        'verifylbexit',
        'labour exit',
        'labourexit',
        'lbexit',
    ];
    const isMatch = pathMatches.some(match => path.includes(match)) ||
        category.includes('labour exit') ||
        category.includes('labourexit') ||
        category.includes('lbexit') ||
        title.includes('labour exit') ||
        title.includes('labourexit') ||
        title.includes('lbexit') ||
        displayName.includes('labour exit') ||
        displayName.includes('labourexit') ||
        displayName.includes('lbexit') ||
        workflowType.includes('labour exit') ||
        workflowType.includes('labourexit') ||
        workflowType.includes('lbexit');
    if (isMatch) {
        console.log('✅ Labour Exit Verification detected by:', { path, category, title, displayName, workflowType });
    } else {
        console.log('❌ Labour Exit Verification not detected. Path:', path);
    }
    return isMatch;
};

const isIndentCreationVerification = (path, category, title, displayName, workflowType) => {
    // Never shadow the separate Indent Amend verification page — its path/title also contains
    // "verifyindent" as a substring (verifyindentAMEND), so it must be excluded here.
    const isAmendPage = path.includes('amend') || category.includes('amend') ||
        title.includes('amend') || displayName.includes('amend') || workflowType.includes('amend');
    if (isAmendPage) return false;

    const pathMatches = [
        '/purchase/verifyindentcreation',
        '/purchase/verifyindent',
        '/indent/verifyindent',
        'verifyindentcreation',
        'indent creation',
        'indentcreation',
    ];
    const isMatch = pathMatches.some(match => path.includes(match)) ||
        category.includes('indent creation') ||
        category.includes('indentcreation') ||
        category.includes('verifyindent') ||
        title.includes('indent creation') ||
        title.includes('indentcreation') ||
        title.includes('verifyindent') ||
        displayName.includes('indent creation') ||
        displayName.includes('indentcreation') ||
        workflowType.includes('indent creation') ||
        workflowType.includes('indentcreation') ||
        workflowType.includes('verifyindent');
    if (isMatch) {
        console.log('✅ Indent Creation Verification detected by:', { path, category, title, displayName, workflowType });
    } else {
        console.log('❌ Indent Creation Verification not detected. Path:', path);
    }
    return isMatch;
};

const isIndentAmendVerification = (path, category, title, displayName, workflowType) => {
    const pathMatches = [
        '/purchase/verifyindentamend',
        'verifyindentamend',
        'indent amend',
        'indentamend',
    ];
    const isMatch = pathMatches.some(match => path.includes(match)) ||
        category.includes('indent amend') ||
        category.includes('indentamend') ||
        title.includes('indent amend') ||
        title.includes('indentamend') ||
        displayName.includes('indent amend') ||
        displayName.includes('indentamend') ||
        workflowType.includes('indent amend') ||
        workflowType.includes('indentamend');
    if (isMatch) {
        console.log('✅ Indent Amend Verification detected by:', { path, category, title, displayName, workflowType });
    } else {
        console.log('❌ Indent Amend Verification not detected. Path:', path);
    }
    return isMatch;
};

const isTransferRecieptOthersVerification = (path, category, title, displayName, workflowType) => {
    const pathMatches = [
        '/purchase/transferrecieptothers',
        '/purchase/transferreciptothers',
        'transferrecieptothers',
        'transferreciptothers',
        'mrr verification',
        'mrr others',
    ];
    const isMatch = pathMatches.some(match => path.includes(match)) ||
        category.includes('transfer reciept') ||
        category.includes('mrr') ||
        title.includes('transfer reciept') ||
        title.includes('mrr') ||
        displayName.includes('transfer reciept') ||
        displayName.includes('mrr') ||
        workflowType.includes('transferrecieptothers') ||
        workflowType.includes('mrr');
    if (isMatch) {
        console.log('✅ MRR (Transfer Reciept Others) Verification detected by:', { path, category, title, displayName, workflowType });
    } else {
        console.log('❌ MRR (Transfer Reciept Others) Verification not detected. Path:', path);
    }
    return isMatch;
};

const isNewStockReceivedVerification = (path, category, title, displayName, workflowType) => {
    const pathMatches = [
        '/purchase/verifynewstockreceived',
        'verifynewstockreceived',
        'new stock received',
        'newstockreceived',
    ];
    const isMatch = pathMatches.some(match => path.includes(match)) ||
        category.includes('new stock received') ||
        category.includes('newstockreceived') ||
        title.includes('new stock received') ||
        title.includes('newstockreceived') ||
        displayName.includes('new stock received') ||
        displayName.includes('newstockreceived') ||
        workflowType.includes('new stock received') ||
        workflowType.includes('newstockreceived');
    if (isMatch) {
        console.log('✅ New Stock Received Verification detected by:', { path, category, title, displayName, workflowType });
    } else {
        console.log('❌ New Stock Received Verification not detected. Path:', path);
    }
    return isMatch;
};

const isHRAdvancePaymentVerification = (path) => {
    const isMatch = path.includes('/hr/verifyhradvancepayment') ||
                    path.includes('/hr/verifyhradpayment');
    if (isMatch) {
        console.log('✅ HR Advance Payment Verification detected by path:', path);
    } else {
        console.log('❌ HR Advance Payment not detected. Path:', path);
    }
    return isMatch;
};

const isAppraisalObjectiveVerification = (path) => {
    const isMatch = path.includes('/hr/verifyappraisalobjectives') ||
        path.includes('/hr/verifyempobjectivesgoals') ||
        path.includes('/hr/verifyempobjectandgoals') ||
        path.includes('/hr/verifyappraisa') ||
        path.includes('appraisalobjective') ||
        path.includes('verifyempobject');
    if (isMatch) {
        console.log('✅ Appraisal Objective & Goals Verification detected by path:', path);
    } else {
        console.log('❌ Appraisal Objective & Goals not detected. Path:', path);
    }
    return isMatch;
};


// ============================================================================
// MAIN COMPONENT
// ============================================================================

// Bank Account Creation (/AccountsApproval/VerifyBankAccounts). Anchored so it cannot swallow
// other /accountsapproval/verifybank... routes (Deposit, Transfer, Withdrawn).
const isBankAccountsVerification = (path, category) =>
    /\/accountsapproval\/verifybankaccounts(?:$|[?#/])/.test(path) ||
    category === 'bank account creation';

// Bank Deposit (/AccountsApproval/VerifyBankDeposit) — CC cash deposited into a bank.
const isBankDepositVerification = (path, category) =>
    /\/accountsapproval\/verifybankdeposit(?:$|[?#/])/.test(path) ||
    category === 'deposit';

// Bank to Bank Transfer (/AccountsApproval/VerifyBankTransfer).
const isBankTransferVerification = (path, category) =>
    /\/accountsapproval\/verifybanktransfer(?:$|[?#/])/.test(path) ||
    category === 'bank to bank transfer';

// Bank Withdrawal (/AccountsApproval/VerifyBankWithdrawn).
const isBankWithdrawalVerification = (path, category) =>
    /\/accountsapproval\/verifybankwithdrawn(?:$|[?#/])/.test(path) ||
    category === 'bank withdrawal';

// Cheque Book (/AccountsApproval/VerifyCheque).
const isChequeVerification = (path, category) =>
    /\/accountsapproval\/verifycheque(?:$|[?#/])/.test(path) ||
    category === 'bank cheque verification';

// Close-master verification (/Home/VerifyClose<Type>) — one shared page, keyed by close type.
// Returns the VerifyCloseMaster closeType, or null when the notification is not a closing request.
const CLOSE_PATH_TYPES = {
    bank: 'Bank', it: 'IT', costcenter: 'CostCenter', dca: 'DCA',
    subdca: 'SubDCA', client: 'Client', subclient: 'SubClient', tlagency: 'TermLoanAgency',
};
const CLOSE_CATEGORY_TYPES = {
    'close bankaccount': 'Bank', 'close it': 'IT', 'close cost center(pcc)': 'CostCenter',
    'close cost center(npcc)': 'CostCenter', 'close accounthead': 'DCA', 'close subaccounthead': 'SubDCA',
    'close client': 'Client', 'close subclient': 'SubClient', 'close tlagency': 'TermLoanAgency',
};
const getCloseMasterType = (path, category) => {
    const m = /\/home\/verifyclose([a-z]+)(?:$|[?#/])/.exec(path);
    return (m && CLOSE_PATH_TYPES[m[1]]) || CLOSE_CATEGORY_TYPES[category] || null;
};

// Open FD (/AccountsApproval/VerifyOpenFD).
const isOpenFDVerification = (path, category) =>
    /\/accountsapproval\/verifyopenfd(?:$|[?#/])/.test(path) ||
    category === 'fdopen';

// VerifyPartialFD (/accountsapproval/verifypartialfd).
const isPartialFDVerification = (path, category) =>
    /\/accountsapproval\/verifypartialfd(?:$|[?#/])/.test(path) ||
    category === 'fdpartial';

// Close FD (/AccountsApproval/VerifyCloseFD) — same page as Partial FD, in Close mode.
const isCloseFDVerification = (path, category) =>
    /\/accountsapproval\/verifyclosefd(?:$|[?#/])/.test(path) ||
    category === 'fdclose';

// VerifyFDInterest (/accountsapproval/verifyfdinterest).
const isFDInterestVerification = (path, category) =>
    /\/accountsapproval\/verifyfdinterest(?:$|[?#/])/.test(path) ||
    category === 'fd interest';

// VerifyTermLoan (/accountsapproval/verifytermloan).
const isTermLoanVerification = (path, category) =>
    /\/accountsapproval\/verifytermloan(?:$|[?#/])/.test(path) ||
    category === 'term loan verification';

// VerifyTLAgency (/accountsapproval/verifytermloanagency).
const isTLAgencyVerification = (path, category) =>
    /\/accountsapproval\/verifytermloanagency(?:$|[?#/])/.test(path) ||
    category === 'tl agency verification';

// VerifyTLPayment (/accountsapproval/verifytermloanpayment).
const isTLPaymentVerification = (path, category) =>
    /\/accountsapproval\/verifytermloanpayment(?:$|[?#/])/.test(path) ||
    category === 'tlpayment verification';

// Unsecured Loan (/AccountsApproval/VerifyUnsecuredLoan | ...Existing | ...Return) — one page keyed by
// loan type. Returns the loanType, or null when the notification is not an unsecured loan.
const UNSECURED_LOAN_CATEGORY_TYPES = {
    'unsecuredloan(new)': 'New', 'unsecuredloan(existing)': 'Existing', 'unsecuredloan(return)': 'Return',
};
const getUnsecuredLoanType = (path, category) => {
    const m = /\/accountsapproval\/verifyunsecuredloan(existing|return)?(?:$|[?#/])/.exec(path);
    if (m) return m[1] === 'existing' ? 'Existing' : m[1] === 'return' ? 'Return' : 'New';
    return UNSECURED_LOAN_CATEGORY_TYPES[category] || null;
};

// VerifyUnsLoanInterest (/accounts/verifyunsloaninterest).
const isUnsLoanInterestVerification = (path, category) =>
    /\/accounts\/verifyunsloaninterest(?:$|[?#/])/.test(path) ||
    category === 'updateunsloan interest';

// VerifyShareCapital (/accountsapproval/verifysharecapital).
const isShareCapitalVerification = (path, category) =>
    /\/accountsapproval\/verifysharecapital(?:$|[?#/])/.test(path) ||
    category === 'share capital verification';

// VerifyShareCreation (/accountsapproval/verifysharecreation).
const isShareCreationVerification = (path, category) =>
    /\/accountsapproval\/verifysharecreation(?:$|[?#/])/.test(path) ||
    category === 'share detail verification';

const InboxRouter = ({ notificationData, onNavigate }) => {
    console.log('🔍 InboxRouter received notification:', notificationData);

    // ========================================================================
    // MAIN ROUTING FUNCTION
    // ========================================================================
    const getVerificationComponent = (notification) => {
        // ✅ USAGE #1: When no notification data is provided
        if (!notification) {
            console.log('❌ No notification data provided');
            return <InboxItemPlaceholder notificationData={null} onNavigate={onNavigate} />;
        }

        const {
            ModuleDisplayName,
            ModuleCategory,
            NavigationPath,
            InboxTitle,
            MasterId,
            WorkflowType
        } = notification;

        // Convert to lowercase for easier matching
        const path = (NavigationPath || '').toLowerCase();
        const category = (ModuleCategory || '').toLowerCase();
        const title = (InboxTitle || '').toLowerCase();
        const displayName = (ModuleDisplayName || '').toLowerCase();
        const workflowType = (WorkflowType || '').toLowerCase();

        console.log('🎯 Routing inputs:', {
            path, category, title, displayName, workflowType, masterId: MasterId
        });

        // ====================================================================
        // STAFF REGISTRATION VERIFICATION
        // ====================================================================
        if (isStaffRegistrationVerification(path, category, title, displayName, workflowType)) {
            console.log('✅ Routing to VerifyStaffRegistration');
            return <VerifyStaffRegistration
                notificationData={notification}
                onNavigate={onNavigate}
            />;
        }

        // ====================================================================
        // VENDOR VERIFICATION (Vendor Creation workflow — /Purchase/VerifyVendor).
        // Checked before the vendor payment branches below; its matcher is anchored so it
        // cannot match their "verifyvendorpayment..." paths.
        // ====================================================================
        if (isVendorCreationVerification(path, category, title, displayName, workflowType)) {
            console.log('✅ Routing to VerifyVendor');
            return <VerifyVendor
                notificationData={notification}
                onNavigate={onNavigate}
            />;
        }

        // ====================================================================
        // VENDOR CASH PAYMENT VERIFICATION  (Paytype=Cash)
        // ====================================================================
        if (isVendorCashPaymentVerification(path)) {
            console.log('✅ Routing to VerifyVendorPaymentByCash');
            return <VerifyVendorPaymentByCash
                notificationData={notification}
                onNavigate={onNavigate}
            />;
        }

        // ====================================================================
        // VENDOR PAYMENT VERIFICATION  (Paytype=Bank)
        // ====================================================================
        if (isVendorPaymentVerification(path, category, title, displayName, workflowType)) {
            console.log('✅ Routing to VerifyVendorPayment');
            return <VerifyVendorPayment
                notificationData={notification}
                onNavigate={onNavigate}
            />;
        }

        // ====================================================================
        // SUPPLIER INVOICE VERIFICATION
        // ====================================================================
        if (isSupplierInvoiceVerification(path, category, title, displayName, workflowType)) {
            console.log('✅ Routing to VerifySupplierInvoice');
            return <VerifySupplierInvoice
                notificationData={notification}
                onNavigate={onNavigate}
            />;
        }

        // ====================================================================
        // SUPPLIER PO AMENDMENT VERIFICATION (checked before the plain Supplier PO
        // match below, since its path/title also contains "supplier po")
        // ====================================================================
        if (isSupplierPOAmendVerification(path, category, title, displayName, workflowType)) {
            console.log('✅ Routing to VerifySupplierPOAmend');
            return <VerifySupplierPOAmend
                notificationData={notification}
                onNavigate={onNavigate}
            />;
        }

        // ====================================================================
        // SUPPLIER PO VERIFICATION
        // ====================================================================
        if (isSupplierPOVerification(path, category, title, displayName, workflowType)) {
            console.log('✅ Routing to VerifySupplierPO');
            return <VerifySupplierPO
                notificationData={notification}
                onNavigate={onNavigate}
            />;
        }

     

        // ====================================================================
        // COST CENTER APPROVAL VERIFICATION
        // ==================================================================== 
        if (isCostCenterApproval(path, category, title, displayName, workflowType)) {
            console.log('✅ Routing to Cost Center Approval Component');
            return <CostCenterApproval
                notificationData={notification}
                onNavigate={onNavigate}
            />;
        }

        // ====================================================================
        // GENERAL INVOICE APPROVAL VERIFICATION
        // ====================================================================
        if (isGeneralInvoiceApproval(path, category, title, displayName, workflowType)) {
            console.log('✅ Routing to General Invoice Approval Component');
            return <GeneralInvoiceApproval
                notificationData={notification}
                onNavigate={onNavigate}
            />;
        }

        // ====================================================================
        // CC BUDGET AMENDMENT VERIFICATION
        // ====================================================================
        if (isCCBudgetAmendmentVerification(path, category, title, displayName, workflowType)) {
            console.log('✅ Routing to VerifyCCBudgetAmendment');
            return <VerifyCCBudgetAmendment
                notificationData={notification}
                onNavigate={onNavigate}
            />;
        }

        // ====================================================================
        // DCA BUDGET AMENDMENT VERIFICATION
        // ==================================================================== 
        if (isDCABudgetAmendmentVerification(path, category, title, displayName, workflowType)) {
            console.log('✅ Routing to VerifyDCABudgetAmendment');
            return <VerifyDCABudgetAmendment
                notificationData={notification}
                onNavigate={onNavigate}
            />;
        }
        // ====================================================================

        // CLIENT PO VERIFICATION
        // ==================================================================== 
        if (isClientPOVerification(path, category, title, displayName, workflowType)) {
            console.log('✅ Routing to VerifyClientPO');
            return <VerifyClientPO
                notificationData={notification}
                onNavigate={onNavigate}
            />;
        }
        // ====================================================================

        // MISCELLANEOUS PAYMENT VERIFICATION (must precede Misc Invoice check below —
        // its path/category/title substrings would otherwise also match this route)
        // ====================================================================
        if (isMiscPaymentVerification(path, category, title, displayName, workflowType)) {
            console.log('✅ Routing to VerifyMiscPayment');
            return <VerifyMiscPayment
                notificationData={notification}
                onNavigate={onNavigate}
            />;
        }
        // ====================================================================

        // MISCELLANEOUS TAXABLE INVOICE VERIFICATION
        // ====================================================================
        if (isMiscInvoiceVerification(path, category, title, displayName, workflowType)) {
            console.log('✅ Routing to VerifyMiscInvoice');
            return <VerifyMiscInvoice
                notificationData={notification}
                onNavigate={onNavigate}
            />;
        }
        // ====================================================================

        // CLIENT RECEIPT (INVOICE SERVICE) VERIFICATION
        // ====================================================================
        if (isClientRecievableVerification(path, category, title, displayName, workflowType)) {
            console.log('✅ Routing to VerifyClientRecievable');
            return <VerifyClientRecievable
                notificationData={notification}
                onNavigate={onNavigate}
            />;
        }

        // ADVANCE PAYMENT VERIFICATION
        // ====================================================================
        if (isAdvancePaymentVerification(path, category, title, displayName, workflowType)) {
            console.log('✅ Routing to VerifyAdvancePayment');
            return <VerifyAdvancePayment
                notificationData={notification}
                onNavigate={onNavigate}
            />;
        }

        // RETENTION PAYMENT VERIFICATION
        // ====================================================================
        if (isRetentionPaymentVerification(path, category, title, displayName, workflowType)) {
            console.log('✅ Routing to VerifyRetentionPayment');
            return <VerifyRetentionPayment
                notificationData={notification}
                onNavigate={onNavigate}
            />;
        }

        // HOLD PAYMENT VERIFICATION
        // ====================================================================
        if (isHoldPaymentVerification(path, category, title, displayName, workflowType)) {
            console.log('✅ Routing to VerifyHoldPayment');
            return <VerifyHoldPayment
                notificationData={notification}
                onNavigate={onNavigate}
            />;
        }
        // ====================================================================

        // RECEIPT AGAINST SCRAP SALE VERIFICATION
        // ====================================================================
        if (isReceiptAgainstScrapSaleVerification(path, category, title, displayName, workflowType)) {
            console.log('✅ Routing to VerifyReceiptAgainstScrapSale');
            return <VerifyReceiptAgainstScrapSale
                notificationData={notification}
                onNavigate={onNavigate}
            />;
        }
        // ====================================================================

        // REFUND VERIFICATION
        // ====================================================================
        if (isRefundVerification(path, category, title, displayName, workflowType)) {
            console.log('✅ Routing to VerifyRefund');
            return <VerifyRefund
                notificationData={notification}
                onNavigate={onNavigate}
            />;
        }
        // ====================================================================

        // CENTRAL DAY BOOK VERIFICATION
        // ====================================================================
        if (isCentralDayBookVerification(path, category, title, displayName, workflowType)) {
            console.log('✅ Routing to VerifyCentralDayBook');
            return <VerifyCentralDayBook
                notificationData={notification}
                onNavigate={onNavigate}
            />;
        }
        // ====================================================================

        // LOST DAMAGED ITEMS VERIFICATION
        // ==================================================================== 
        if (isLostDamagedItemsVerification(path, category, title, displayName, workflowType)) {
            console.log('✅ Routing to VerifyLostDamagedItems');
            return <LostDamagedItemsVerification
                notificationData={notification}
                onNavigate={onNavigate}
            />;
        }
        // ====================================================================

        // DAILY ISSUE VERIFICATION
        // ==================================================================== 
        if (isDailyIssueVerification(path, category, title, displayName, workflowType)) {
            console.log('✅ Routing to VerifyDailyIssue');
            return <VerifyDailyIssue
                notificationData={notification}
                onNavigate={onNavigate}
            />;
        }
        // ====================================================================

        // SCRAP SALE VERIFICATION
        // ==================================================================== 
        if (isScrapSaleVerification(path, category, title, displayName, workflowType)) {
            console.log('✅ Routing to VerifyScrapSale');
            return <VerifyScrapSale
                notificationData={notification}
                onNavigate={onNavigate}
            />;
        }

        // EXCEL ATTENDANCE VERIFICATION
        // ==================================================================== 
        if (isExcelAttendanceVerification(path, category, title, displayName, workflowType)) {
            console.log('✅ Routing to VerifyExcelAttendance');
            return <VerifyExcelAttendance
                notificationData={notification}
                onNavigate={onNavigate}
            />; 
                
        }

        // ====================================================================
        // SPPO CLOSE VERIFICATION
        // ====================================================================
        if (isSPPOCloseVerification(path, category, title, displayName, workflowType)) {
            console.log('✅ Routing to VerifySPPOClose');
            return <VerifySPPOClose
                notificationData={notification}
                onNavigate={onNavigate}
            />;
        }

        // ====================================================================
        // SPPO AMEND VERIFICATION
        // ====================================================================
        if (isSPPOAmendVerification(path, category, title, displayName, workflowType)) {
            console.log('✅ Routing to VerifySPPOAmend');
            return <VerifySPPOAmend
                notificationData={notification}
                onNavigate={onNavigate}
            />;
        }

           // =====================================================================
        // SPPO VERIFICATION
        //=====================================================================
        if (isSPPOVerification(path, category, title, displayName, workflowType)) {
            console.log('✅ Routing to VerifySPPO');
            return <VerifySPPO
                notificationData={notification}
                onNavigate={onNavigate}
            />;
        }

        // ====================================================================
        // STAFF DAILY ATTENDANCE VERIFICATION
        // ====================================================================
        if (isDailyAttendanceVerification(path, category, title, displayName, workflowType)) {
            console.log('✅ Routing to VerifyStaffDailyAttendance');
            return <VerifyStaffDailyAttendance      
                notificationData={notification}
                onNavigate={onNavigate}
            />;
        }
        // ====================================================================

        // LABOUR OBJECTIVES & GOALS VERIFICATION
        // ====================================================================
        if (isLabourObjectivesGoalsVerification(path)) {
            console.log('✅ Routing to VerifyLabourObjectivesGoals');
            return <VerifyLabourObjectivesGoals
                notificationData={notification}
                onNavigate={onNavigate}
            />;
        }
        // ====================================================================

        // STAFF OBJECTIVES & GOALS VERIFICATION
        // ====================================================================
        if (isStaffObjectivesGoalsVerification(path)) {
            console.log('✅ Routing to VerifyStaffObjectivesGoals');
            return <VerifyStaffObjectivesGoals
                notificationData={notification}
                onNavigate={onNavigate}
            />;
        }
        // ====================================================================

        // EMPLOYEE CTC VERIFICATION
        // ====================================================================
        if (isEmployeeCTCVerification(path)) {
            console.log('✅ Routing to VerifyEmployeeCTC');
            return <VerifyEmployeeCTC
                notificationData={notification}
                onNavigate={onNavigate}
            />;
        }
        // ====================================================================

        // LABOUR CTC VERIFICATION
        // ====================================================================
        if (isLabourCTCVerification(path)) {
            console.log('✅ Routing to VerifyLabourCTC');
            return <VerifyLabourCTC
                notificationData={notification}
                onNavigate={onNavigate}
            />;
        }
        // ====================================================================
        // LABOUR PAYROLL VERIFICATION
        // ====================================================================
        if (isLabourPayrollVerification(path)) {
            console.log('✅ Routing to VerifyLabourPayRoll');
            return <VerifyLabourPayRoll
                notificationData={notification}
                onNavigate={onNavigate}
            />;
        }
        // ====================================================================
        // LABOUR PAY REVISION VERIFICATION
        // ====================================================================
        if (isLabourPayRevisionVerification(path)) {
            console.log('✅ Routing to VerifyLabourPayRevision');
            return <VerifyLabourPayRevision
                notificationData={notification}
                onNavigate={onNavigate}
            />;
        }
        // ====================================================================
        // STAFF PAY REVISION VERIFICATION
        // ====================================================================
        if (isStaffPayRevisionVerification(path)) {
            console.log('✅ Routing to VerifyStaffPayRevision');
            return <VerifyStaffPayRevision
                notificationData={notification}
                onNavigate={onNavigate}
            />;
        }
        // ====================================================================

        // EMPLOYEE LEAVE REQUEST VERIFICATION
        // ====================================================================
        if (isEmployeeLeaveRequestVerification(path)) {
            console.log('✅ Routing to VerifyEmployeeLeaveRequest');
            return <VerifyEmployeeLeaveRequest
                notificationData={notification} 
                onNavigate={onNavigate}
            />;
        }
        // ====================================================================

        // DIVIDEND DECLARATION VERIFICATION
        // ====================================================================
        if (isDividendDeclarationVerification(path)) {
            console.log('✅ Routing to DividendDeclarationVerification');
            return <DividendDeclarationVerification
                notificationData={notification}
                onNavigate={onNavigate}
            />; 
        }
        
        // ====================================================================
        // DIVIDEND DISTRIBUTION VERIFICATION
        // ====================================================================
        if (isDividendDistributionVerification(path)) {
            console.log('✅ Routing to DividendDistributionVerification');
            return <DividendDistributionVerification
                notificationData={notification}
                onNavigate={onNavigate}
            />;
        }
        // ====================================================================
        // DIVIDEND BANK PAYMENT VERIFICATION
        // ====================================================================
        if (isDividendBankPaymentVerification(path)) {
            console.log('✅ Routing to DividendBankPaymentVerification');
            return <DividendBankPaymentVerification
                notificationData={notification}
                onNavigate={onNavigate}
            />;
        }
        // ====================================================================
        // LABOUR CMS PAY VERIFICATION
        // ====================================================================
        if (isLabourCMSPayVerification(path, category, title, displayName, workflowType)) {
            console.log('✅ Routing to VerifyLabourCMSPay');
            return <VerifyLabourCMSPay
                notificationData={notification}
                onNavigate={onNavigate}
            />;
        }

        // ====================================================================
        // STAFF CMS PAY VERIFICATION
        // ====================================================================
        if (isStaffCMSPayVerification(path)) {
            console.log('✅ Routing to VerifyStaffCMSPay');
            return <VerifyStaffCMSPay
                notificationData={notification}
                onNavigate={onNavigate}
            />;
        }

        // ====================================================================
        // STAFF PAYROLL VERIFICATION
        // ====================================================================
        if (isStaffPayrollVerification(path)) {
            console.log('✅ Routing to VerifyStaffPayroll');
            return <VerifyStaffPayroll
                notificationData={notification}
                onNavigate={onNavigate}
            />;
        }

        // ====================================================================
        // SALARY DEDUCTION AREAR VERIFICATION
        // ====================================================================
        if (isSalaryDeductionArearVerification(path)) {
            console.log('✅ Routing to VerifySalaryDeductionArear');
            return <VerifySalaryDeductionArear
                notificationData={notification}
                onNavigate={onNavigate}
            />;
        }
        // ====================================================================
        // EMPLOYEE TRANSFER VERIFICATION
        if (isEmployeeTransferVerification(path)) {
            console.log('✅ Routing to EmployeeTransferVerify');
            return <VerifyEmployeeTransfer
                notificationData={notification}
                onNavigate={onNavigate}
            />;
        }
        // ====================================================================
        // EMPLOYEE EXIT VERIFICATION
        if (path.includes('/hr/verifyempexit') || path.includes('/HR/VerifyEmpExit')) {
            console.log('✅ Routing to EmployeeExitVerify');
            return <VerifyEmployeeExit
                notificationData={notification}
                onNavigate={onNavigate}
            />;
        }

        // ====================================================================
        // LABOUR EXIT VERIFICATION
        if (isLabourExitVerification(path, category, title, displayName, workflowType)) {
            console.log('✅ Routing to VerifyLabourExit');
            return <VerifyLabourExit
                notificationData={notification}
                onNavigate={onNavigate}
            />;
        }

        // ====================================================================
        // STAFF FULL & FINAL VERIFICATION
        // ====================================================================
        if (
            path.includes('finalsalary')   ||
            path.includes('fullfinal')     ||
            path.includes('full & final')  ||
            path.includes('full&final')    ||
            path.includes('fullfinalsalary') ||
            title.includes('full & final') ||
            title.includes('finalsalary')  ||
            displayName.includes('full & final') ||
            displayName.includes('finalsalary')  ||
            category.includes('finalsalary')
        ) {
            console.log('✅ Routing to VerifyStaffFullFinal');
            return <VerifyStaffFullFinal
                notificationData={notification}
                onNavigate={onNavigate}
            />;
        }

        // ====================================================================
        // HR ADVANCE PAYMENT VERIFICATION  (specific path — must be before broad advance check)
        // ====================================================================
        if (isHRAdvancePaymentVerification(path)) {
            console.log('✅ Routing to VerifyHRAdvancePayment');
            return <VerifyHRAdvancePayment
                notificationData={notification}
                onNavigate={onNavigate}
            />;
        }

        // HR Advance Request Verification (LTA / SA)
        if (
            path.includes('advance')        ||
            path.includes('hradvance')      ||
            path.includes('lta')            ||
            path.includes('salaryadvance')  ||
            title.includes('advance')       ||
            displayName.includes('advance') ||
            category.includes('advance')
        ) {
            console.log('✅ Routing to VerifyStaffAdvance');
            return <VerifyStaffAdvance
                notificationData={notification}
                onNavigate={onNavigate}
            />;
        }

        // ====================================================================
        // APPRAISAL OBJECTIVE & GOALS VERIFICATION
        // ====================================================================
        if (
            isAppraisalObjectiveVerification(path) ||
            title.includes('appraisal')            ||
            title.includes('objective')            ||
            displayName.includes('appraisal')      ||
            displayName.includes('objective')      ||
            category.includes('appraisal')         ||
            category.includes('objective')
        ) {
            console.log('✅ Routing to VerifyStaffAppraisal');
            return <VerifyStaffAppraisal
                notificationData={notification}
                onNavigate={onNavigate}
            />;
        }


        // ====================================================================
        // CC CASH TRANSFER VERIFICATION
        // ====================================================================
        if (isCCCashTransferVerification(path, category, title, displayName, workflowType)) {
            console.log('✅ Routing to VerifyCCCashTransfer');
            return <VerifyCCCashTransfer
                notificationData={notification}
                onNavigate={onNavigate}
            />;
        }

        // ====================================================================
        // CC CLOSING VERIFICATION
        // ====================================================================
        if (isCCClosingVerification(path, category, title, displayName, workflowType)) {
            console.log('✅ Routing to VerifyCCClosing');
            return <VerifyCCClosing
                notificationData={notification}
                onNavigate={onNavigate}
            />;
        }

        // ====================================================================
        // LOAD WALLET VERIFICATION
        // ====================================================================
        if (isLoadWalletVerification(path, category, title, displayName, workflowType)) {
            console.log('✅ Routing to VerifyLoadWallet');
            return <VerifyLoadWallet
                notificationData={notification}
                onNavigate={onNavigate}
            />;
        }

        // ====================================================================
        // CASH VOUCHER VERIFICATION
        // ====================================================================
        if (isCashVoucherVerification(path, category, title, displayName, workflowType)) {
            console.log('✅ Routing to VerifyCashVoucher');
            return <VerifyCashVoucher
                notificationData={notification}
                onNavigate={onNavigate}
            />;
        }

        // ====================================================================
        // WORKER & STAFF REGISTRATION VERIFICATION
        // ====================================================================
        if (isWorkerStaffRegVerification(path, category, title, displayName, workflowType)) {
            console.log('✅ Routing to VerifyWorkerStaffReg');
            return <VerifyWorkerStaffReg
                notificationData={notification}
                onNavigate={onNavigate}
            />;
        }

        // ====================================================================
        // LABOUR BANK CHANGE VERIFICATION
        // ====================================================================
        if (isLabourBankChangeVerification(path, category, title, displayName, workflowType)) {
            console.log('✅ Routing to VerifyLabourBankChange');
            return <VerifyLabourBankChange
                notificationData={notification}
                onNavigate={onNavigate}
            />;
        }

        // ====================================================================
        // EMPLOYEE BANK CHANGE VERIFICATION
        // ====================================================================
        if (isEmpBankChangeVerification(path, category, title, displayName, workflowType)) {
            console.log('✅ Routing to VerifyEmpBankChange');
            return <VerifyEmpBankChange
                notificationData={notification}
                onNavigate={onNavigate}
            />;
        }

        // ====================================================================
        // BULK WORKER REGISTRATION VERIFICATION
        // ====================================================================
        if (isBulkWorkerVerification(path, category, title, displayName, workflowType)) {
            console.log('✅ Routing to VerifyBulkWorker');
            return <VerifyBulkWorker
                notificationData={notification}
                onNavigate={onNavigate}
            />;
        }

        // ====================================================================
        // LABOUR TYPE CHANGE VERIFICATION
        // ====================================================================
        if (isLabourTypeChangeVerification(path, category, title, displayName, workflowType)) {
            console.log('✅ Routing to VerifyLabourTypeChange');
            return <VerifyLabourTypeChange
                notificationData={notification}
                onNavigate={onNavigate}
            />;
        }

        // ====================================================================
        // INDENT AMEND VERIFICATION (checked before Indent Creation below, whose own
        // "verifyindent" substring check would otherwise also match this path)
        // ====================================================================
        if (isIndentAmendVerification(path, category, title, displayName, workflowType)) {
            console.log('✅ Routing to VerifyIndentAmend');
            return <VerifyIndentAmend
                notificationData={notification}
                onNavigate={onNavigate}
            />;
        }

        // ====================================================================
        // INDENT CREATION VERIFICATION
        // ====================================================================
        if (isIndentCreationVerification(path, category, title, displayName, workflowType)) {
            console.log('✅ Routing to VerifyIndentCreation');
            return <VerifyIndentCreation
                notificationData={notification}
                onNavigate={onNavigate}
            />;
        }

        // ====================================================================
        // ITEM CODE VERIFICATION
        // ====================================================================
        if (isItemCodeVerification(path, category, title, displayName, workflowType)) {
            console.log('✅ Routing to VerifyItemCode');
            return <VerifyItemCode
                notificationData={notification}
                onNavigate={onNavigate}
            />;
        }

        // ====================================================================
        // MRR (TRANSFER RECIEPT OTHERS) VERIFICATION
        // ====================================================================
        if (isTransferRecieptOthersVerification(path, category, title, displayName, workflowType)) {
            console.log('✅ Routing to TransferRecieptOthersVerification');
            return <TransferRecieptOthersVerification
                notificationData={notification}
                onNavigate={onNavigate}
            />;
        }

        // ====================================================================
        // NEW STOCK RECEIVED VERIFICATION
        // ====================================================================
        if (isNewStockReceivedVerification(path, category, title, displayName, workflowType)) {
            console.log('✅ Routing to VerifyNewStockReceived');
            return <VerifyNewStockReceived
                notificationData={notification}
                onNavigate={onNavigate}
            />;
        }

        // ====================================================================
        // BANK ACCOUNT CREATION VERIFICATION
        // ====================================================================
        if (isBankAccountsVerification(path, category)) {
            return <VerifyBankAccounts
                notificationData={notification}
                onNavigate={onNavigate}
            />;
        }

        // ====================================================================
        // BANK DEPOSIT VERIFICATION
        // ====================================================================
        if (isBankDepositVerification(path, category)) {
            return <VerifyBankDeposit
                notificationData={notification}
                onNavigate={onNavigate}
            />;
        }

        // ====================================================================
        // BANK TO BANK TRANSFER VERIFICATION
        // ====================================================================
        if (isBankTransferVerification(path, category)) {
            return <VerifyBankTransfer
                notificationData={notification}
                onNavigate={onNavigate}
            />;
        }

        // ====================================================================
        // BANK WITHDRAWAL VERIFICATION
        // ====================================================================
        if (isBankWithdrawalVerification(path, category)) {
            return <VerifyBankWithdrawal
                notificationData={notification}
                onNavigate={onNavigate}
            />;
        }

        // ====================================================================
        // CHEQUE BOOK VERIFICATION
        // ====================================================================
        if (isChequeVerification(path, category)) {
            return <VerifyCheque
                notificationData={notification}
                onNavigate={onNavigate}
            />;
        }

        // ====================================================================
        // CLOSE-MASTER VERIFICATION (Bank / IT / CC / DCA / SubDCA / Client / SubClient / TL Agency)
        // ====================================================================
        const closeMasterType = getCloseMasterType(path, category);
        if (closeMasterType) {
            return <VerifyCloseMaster
                key={closeMasterType}
                closeType={closeMasterType}
                notificationData={notification}
                onNavigate={onNavigate}
            />;
        }

        // ====================================================================
        // OPEN FD VERIFICATION
        // ====================================================================
        if (isOpenFDVerification(path, category)) {
            return <VerifyOpenFD
                notificationData={notification}
                onNavigate={onNavigate}
            />;
        }

        if (isPartialFDVerification(path, category)) {
            return <VerifyPartialFD
                notificationData={notification}
                onNavigate={onNavigate}
            />;
        }

        if (isCloseFDVerification(path, category)) {
            return <VerifyPartialFD
                key="close-fd"
                fdMode="Close"
                notificationData={notification}
                onNavigate={onNavigate}
            />;
        }

        if (isFDInterestVerification(path, category)) {
            return <VerifyFDInterest
                notificationData={notification}
                onNavigate={onNavigate}
            />;
        }

        if (isTermLoanVerification(path, category)) {
            return <VerifyTermLoan
                notificationData={notification}
                onNavigate={onNavigate}
            />;
        }

        if (isTLAgencyVerification(path, category)) {
            return <VerifyTLAgency
                notificationData={notification}
                onNavigate={onNavigate}
            />;
        }

        if (isTLPaymentVerification(path, category)) {
            return <VerifyTLPayment
                notificationData={notification}
                onNavigate={onNavigate}
            />;
        }

        const unsecuredLoanType = getUnsecuredLoanType(path, category);
        if (unsecuredLoanType) {
            return <VerifyUnsecuredLoan
                key={unsecuredLoanType}
                loanType={unsecuredLoanType}
                notificationData={notification}
                onNavigate={onNavigate}
            />;
        }

        if (isUnsLoanInterestVerification(path, category)) {
            return <VerifyUnsLoanInterest
                notificationData={notification}
                onNavigate={onNavigate}
            />;
        }

        if (isShareCapitalVerification(path, category)) {
            return <VerifyShareCapital
                notificationData={notification}
                onNavigate={onNavigate}
            />;
        }

        if (isShareCreationVerification(path, category)) {
            return <VerifyShareCreation
                notificationData={notification}
                onNavigate={onNavigate}
            />;
        }

        // ====================================================================
        // CONFIG-DRIVEN VERIFICATION PAGES (pages/Accounts/verificationConfigs.jsx)
        // ====================================================================
        const configVerificationKey = getConfigVerificationKey(path, category);
        if (configVerificationKey) {
            return <ConfigVerification
                key={configVerificationKey}
                configKey={configVerificationKey}
                notificationData={notification}
                onNavigate={onNavigate}
            />;
        }

        // ✅ USAGE #2: When no specific component matches the notification
        console.log('⚠️ No specific component found, using placeholder');
        return <InboxItemPlaceholder
            notificationData={notification}
            onNavigate={onNavigate}
        />;
    };

    // ========================================================================
    // RENDER
    // ========================================================================
    return (
        <div className="inbox-router">
            {getVerificationComponent(notificationData)}
        </div>
    );
};

export default InboxRouter;